import React, { useState } from "react";
import { Link } from 'react-router-dom';



const ProductCard = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  return (
    
    <li>
                  <Link to={`/products/${props.id}`} className="relative block rounded-tr-3xl border border-gray-100">
  <img
    src={typeof(props.image) == "object" ? require(`../assets/img${props.image[0]}`) : require(`../assets/img${props.image}`)}
                      alt={props.name}
    className="h-80 w-full rounded-tr-3xl object-contain"
  />

  <div className="p-4 text-center">
    <strong className="text-l font-medium text-gray-900 min-h-16 block"> {props.name} </strong>

    <p className="mt-2 text-pretty text-gray-700 line-clamp-3 min-h-16">
      {props.description}
    </p>

    <span aria-label={`Learn More About ${props.name}`}
      className="mt-4 bottom-4 block rounded-md border border-indigo-900 bg-indigo-900 px-5 py-3 text-sm font-medium uppercase tracking-widest text-white transition-colors hover:bg-white hover:text-indigo-900"
    >
      Learn More
    </span>
  </div>
</Link>
                </li>
  );
};

export default ProductCard;
